import React from 'react';
import {BaseModal} from '../../comun/Index';
import { TextField, Autocomplete } from '@mui/material';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      localidadSelec:null
    }
  }
  componentDidMount(){  }

  guardar(){
    const localidad_id = this.state.localidadSelec.id;
    this.props.guardar({localidad_id});
  }

  render(){
    const {localidadSelec} = this.state;
    const {localidades} = this.props;
    return(
      <BaseModal
        titulo="Datos de Usuario"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.guardar()}
        ]}
      >
        <div className="Seccion" style={{width:'90%'}}>
          <Autocomplete
            value={localidadSelec}
            onChange={(e,n) => this.setState({localidadSelec:n})}
            isOptionEqualToValue={(option, value) => option.id === value.id }
            slotProps={{style:{textAlign:'center'}}}
            options={localidades}
            getOptionLabel={(option) => option.descripcion}
            size="small"
            disableClearable
            style={{margin:'5px 1px',flex:1, fontSize:5}}
            fontSize="small"
            renderInput={(params) => <TextField {...params} label="Localidad"/>}
          />
        </div>
      </BaseModal>
    );
  }
}

export default Nueva;
